<div
    class="engine-fade"
    [@fade]="{ value: isVisible, params: { backgroundColor: color, duration: duration }}"
    (@fade.done)="handleFadeComplete()"></div>